module.exports = __webpack_public_path__ + "static/media/trust.89b069f2.svg";